import { render, staticRenderFns } from "./EditScormDetailsDlg.vue?vue&type=template&id=10a3604a&"
import script from "./EditScormDetailsDlg.vue?vue&type=script&lang=ts&"
export * from "./EditScormDetailsDlg.vue?vue&type=script&lang=ts&"
import style0 from "./EditScormDetailsDlg.vue?vue&type=style&index=0&id=10a3604a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports